<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <h2>Cloud</h2>
        <ul>
          <li><a routerLink="/services">Services</a></li>
          <li>Cloud</li>
        </ul>
      </div>
    </div>
  </div>